import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import BreadcrumbGroup from "@amzn/awsui-components-react-v3/polaris/breadcrumb-group";

import { getBreadCrumbItems } from "./pageHeaderUtils";
import { PageHeaderProps } from "./pageHeader.interface";

export const PageHeader = ({ title,breadCrumbUpdateQuery }: PageHeaderProps) => {
  const location = useLocation();

  const breadCrumbItems = useMemo(() => {
    return getBreadCrumbItems(location,breadCrumbUpdateQuery);
  }, [location]);

  return (
    <div id="pageHeader">
        <h1 data-testid="header-title">{title}</h1>
        <BreadcrumbGroup
          className="mr-4"
          items={breadCrumbItems.map((item) => ({
            text: item.pageName,
            href: item.link,
          }))}
        />
    </div>
  );
};
